export default "__VITE_PUBLIC_ASSET__88f0143c__"